import React from 'react';
import { Tooltip } from 'antd';
import cx from 'classnames';

import { getFormattedUTCDate } from 'utils/dateUtils';

import styles from './LastSyncDateSection.module.less';

type Props = {
  syncDate: Date;
  title: string;
};

export default function LastSyncDateSection(props: Props) {
  const { syncDate, title } = props;

  return (
    <div className={styles.root}>
      <span>Last Data Synchronization: </span>
      {getFormattedUTCDate(syncDate)}
      <Tooltip
        overlayClassName={cx('light-tooltip', styles.tooltipMessage)}
        title={title}
        trigger="click"
        placement="bottomRight"
        getPopupContainer={(triggerNode) =>
          triggerNode.parentNode as HTMLElement
        }
      >
        <span className={cx(styles.icon, 'icon icon-attention-filled')} />
      </Tooltip>
    </div>
  );
}
